module.exports = __webpack_public_path__ + "assets/img/exposure.4d308d77.svg";